import ReCAPTCHA from "react-google-recaptcha";//main
import React, { useEffect, useState, useRef } from "react";
import "./productList.module.css";
import "../../black-box/custom.css";
import "react-toastify/dist/ReactToastify.css";
import { IoHeartOutline, IoHeart } from "react-icons/io5";
import { useCookies } from "react-cookie";
// import { LoadingOverlay, Loader } from "react-overlay-loader";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { TextField } from "@material-ui/core";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


if (window.Shopify.shop === "padis-gems.myshopify.com") {
    require("../../black-box/customCssForPadis.css");
}
if (window.Shopify.shop === "ostara-fashion.myshopify.com") {
    require("../../black-box/customCssForOstara.css");
}
const ProductListPage = ({ props }) => {
    // console.log(process.env.REACT_APP_API_URL);
    let errors = {};
    let formIsValid = true;
    const currency = window.ShopifyAnalytics.meta.currency;

    const [addtolistError, setaddtolistError] = useState(false);

    const [getFirstname, setFirstname] = useState("");
    const [getLastname, setLastname] = useState("");
    const [getPhone, setPhone] = useState("");
    const [getyouremail, setyouremail] = useState("");
    const [geterror, seterror] = useState([""]);

    const [WishlistComment, setWishlistComment] = useState('');
    const [WishlistCommenttoggle, setWishlistCommenttoggle] = useState(false);

    const [planUpgradable, setplanUpgradable] = useState(false);
    const [productDetail, setproductDetail] = useState(['']);
    const [productQuantity, setproductQuantity] = useState(0);
    const [getWishlist, setWishlist] = useState([]);
    const [getWishlistItem, setWishlistItem] = useState([""]);
    const [reCaptchaValue, setReCaptchaValue] = useState("");
    const [click, setClick] = useState(false);
    const [cookies, setCookie] = useCookies("gemfind_sessionId");
    const [loaded, setLoaded] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const [setting, setSetting] = useState(false);
    const [loadApi, setloadApi] = useState(false);
    const [newwishlist, setnewwishlist] = useState('');
    const [Selectwishlist, setSelectwishlist] = useState('');
    const [newwishlistfields, setnewwishlistfields] = useState(false);




    const handleFirstname = event => {
        let fname = document.getElementById("fname").value;
        setFirstname(fname);
    };
    const handleLastname = event => {
        let lname = document.getElementById("lname").value;
        setLastname(lname);
    };
    const handlePhone = event => {
        let phone = document.getElementById("phone").value;
        setPhone(phone);
    };
    const handleYouremail = event => {
        let email = document.getElementById("email").value;
        setyouremail(email);
    };




    const addFormData = async () => {
        setLoaded(true);
        //VALIDATION
        if (getFirstname === "") {
            errors["first"] = "Please enter your First name";
            formIsValid = false;
        }
        if (getLastname === "") {
            errors["last"] = "Please enter your Last name";
            formIsValid = false;
        }
        if (getPhone === "") {
            errors["phone"] = "Please enter your Phone number ";
            formIsValid = false;
        }
        const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (regex.test(getyouremail) === false) {
            errors["email"] = "Please enter valid email";
            formIsValid = false;
        }
        if (formIsValid == false) {
            console.log(errors);
            seterror(errors);
            setLoaded(false);
            return;
        }
        var variant_sku = "";
        var product_url = window.Shopify.shop + "/products/" + props;
        variant_sku = props;
        const requestOptions1 = {
            method: "POST",
            // mode:'no-cros',
            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                session_id: cookies.gemfind_sessionId,
                handle: props,
                customer_id:
                    window.meta.page.customerId != undefined
                        ? window.meta.page.customerId
                        : null,
                fname: getFirstname,
                lname: getLastname,
                phone: getPhone,
                email: getyouremail,
                variantId: "42179154116787",
                productName: "11-6867W6-G",
                productSku: variant_sku,
                productUrl: product_url,
                productId: "123"
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "sendMailData",
            requestOptions1
        );
        const reqData = await res.json();
        if (reqData.status === "success") {
            toast("Email Sent Successfully!");
        } else {
            toast("Email Could not be sent ");
        }
        setIsOpen2(false);
        setLoaded(false);
        setReCaptchaValue("");
        props.callback(reqData.message);
    };

    const getProductDetails = async () => {
        const requestOptions = {
            method: "GET",
        };
        const res = await fetch(
            "https://" + window.Shopify.shop + "/products/" + props + ".js",
            requestOptions
        );
        const set_count = await res.json();
        setproductDetail(set_count);
    }
    useEffect(() => {
        if (isOpen) {
            getProductDetails();
        }
    }, [isOpen])
    const getQuotedProductCount = async () => {
        setLoaded(true);
        // 
        const requestOptions = {
            method: "POST",
            // mode: "no-cors",
            // headers: {
            //     'Content-Type': 'application/json'
            // },
            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                session_id: cookies.gemfind_sessionId,
                saveforlater: "false",
                product_id: "",
                customer_id:
                    window.meta.page.customerId != undefined
                        ? window.meta.page.customerId
                        : null
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "myWishlist",
            requestOptions
        );
        const set_count = await res.json();
        // console.log(set_count);
        setWishlist(set_count.data.wishlists);
        setWishlistItem(set_count.data.wishlist_status);
        setLoaded(false);
    };
    useEffect(() => {
        if (loadApi === true) {
            getQuotedProductCount();
            setloadApi(false);
        }
    }, [loadApi, getWishlist]);
    const handleAddClick = async e => {
        // console.log(e.target.parentNode.parentNode.parentNode.id);
        setLoaded(true);


        const requestOptions = {
            method: "POST",
            // mode: 'no-cors',
            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                session_id: cookies.gemfind_sessionId,
                handle: props,
                product_id: "",
                saveforlater: 'false',
                comments: WishlistComment != '' ? WishlistComment.target.value : '',
                quantity: productQuantity,

                wishlist_id: setting.multiple_wishlist_option !== "false" ? newwishlistfields ? newwishlist.target.value : Selectwishlist.target.value != '' ? Selectwishlist.target.value : '--' : Selectwishlist,

                customer_id:
                    window.meta.page.customerId != undefined
                        ? window.meta.page.customerId
                        : null
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "addToWishlist",
            requestOptions
        );
        // const set_count = await res.json();
        setClick(true);
        setLoaded(false);
        setIsOpen(false);
        setIsOpen2(true);
        // console.log(click);
    };

    const handleRemoveClick = async e => {
        // console.log(e.target.parentNode.parentNode.parentNode.id);
        setLoaded(true);
        const requestOptions = {
            method: "POST",
            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                session_id: cookies.gemfind_sessionId,
                handle: props,
                saveforlater: "false",
                product_id: "",
                customer_id:
                    window.meta.page.customerId != undefined
                        ? window.meta.page.customerId
                        : null
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "removeWishlist",
            requestOptions
        );
        const set_count = await res.json();
        setClick(false);
        setLoaded(false);
        // console.log(click);
    };
    //FOR ADD DATA IN POP_UP FORM


    //FOR GETTING PRODUCT LIST
    const handleproductInWishlist = async () => {
        // setLoaded(true);
        const requestOptions = {
            method: "POST",
            // mode: 'no-cors',
            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                session_id: cookies.gemfind_sessionId,
                handle: props,
                saveforlater: "false",
                product_id: "",
                customer_id:
                    window.meta.page.customerId != undefined
                        ? window.meta.page.customerId
                        : null
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "productInWishlist",
            requestOptions
        );
        const set_count = await res.json();
        setClick(set_count.data.wishlist_status);
        // setLoaded(false);
        // console.log(set_count);
    };
    const handleAppSetting = async () => {
        // setLoaded(true);
        const requestOptions = {
            method: "POST",
            body: JSON.stringify({
                shop_domain: window.Shopify.shop
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "appSetting",
            requestOptions
        );
        const app_setting = await res.json();
        setSetting(app_setting.data);
        if (app_setting.data.plan <= 1) {
            setproductQuantity(1);
        }
        if (app_setting.data.multiple_wishlist_option == "false") {
            setproductQuantity(1);
            setSelectwishlist("My Wishlist");
        }
        // console.log(app_setting);
    };
    function onChange(value) {
        // console.log("Captcha value:", value);
        setReCaptchaValue(value);
    }
    // console.log(reCaptchaValue);
    useEffect(() => {
        handleproductInWishlist();
        handleAppSetting();
    }, [click]);

    const wishlistCount = async data => {
        const requestOptions = {
            method: "POST",
            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                customer_id:
                    window.meta.page.customerId != undefined
                        ? window.meta.page.customerId
                        : null,
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "wishlistCount",
            requestOptions
        );
        const set_count = await res.json();
        if (set_count) {
            if (set_count.data.wishlist_plan_upgradable) {
                setplanUpgradable(set_count.data.wishlist_plan_upgradable);
                // console.log(set_count)
            }
        }
    };

    useEffect(() => {
        wishlistCount();
    }, [])
    useEffect(()=>{
        if(loaded){
            document.querySelector(".gf--loader--body").style="display:block;";
        }else{
            document.querySelector(".gf--loader--body").style="display:none;";
        }
    },[loaded]);

    // useEffect(() => {
    //     if (Object.keys(getWishlist).length > 0) {
    //         const firstKey = Object.keys(getWishlist)[0];
    //         setSelectwishlist(getWishlist[firstKey]);
    //     }
    // }, [getWishlist]);

    useEffect(() => {
        if (loaded) {
            document.body.classList.add("gf---loading");
        } else {
            document.body.classList.remove("gf---loading");
        }
    }, [loaded]);

    if (setting.captcha_select === 1 && setting.site_key !== "") {
        return (
            <div id='ProductListPageContainer'>
                <style>
                    {`
                .heart{
                    color: ${setting.wishlist_icon_color}
                }
                .react-overlay-loader-spinner {
                    background-image: url(${process.env.REACT_APP_IMAGE_URL}+"images/heart_loader.gif");
                }
            `}
                </style>

                {planUpgradable ?
                    <Modal
                        open={isOpen}
                        onClose={() => setIsOpen(false)}
                        center
                        classNames={{
                            overlay: "popup_Overlay",
                            modal: "popup-form-extra-small plan--modal"
                        }}
                    >
                        <p>Wishlist limit is over, Please contact Us for more information.</p>
                    </Modal>
                    :
                    <>
                        {setting.request_info == "true" ?
                            <Modal
                                open={isOpen2}
                                onClose={() => { setIsOpen2(false); setnewwishlistfields(false); }}
                                center
                                classNames={{
                                    overlay: "popup_Overlay",
                                    modal: "popup-form-extra-small"
                                }}
                            >
                                {/* <LoadingOverlay className="_loading_overlay_wrapper">
                                    <Loader fullPage loading={loaded} />
                                </LoadingOverlay> */}
                                <div className="Diamond-form--xx-small request--more-info-popup">
                                    <div className="requested-form">
                                        <h2>Request More Information</h2>
                                    </div>
                                    <form
                                        // onSubmit={ () =>
                                        //     addFormData(props.props)
                                        // }
                                        className="email-form"
                                    >
                                        <div className="form-field">
                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <div style={{ width: "100%" }}>
                                                    <TextField
                                                        id="fname"
                                                        label="* First name:"
                                                        variant="outlined"
                                                        focused
                                                        value={getFirstname}
                                                        onChange={handleFirstname}
                                                    />
                                                    <p> {geterror.first} </p>
                                                </div>
                                                <div style={{ width: "100%" }}>
                                                    <TextField
                                                        id="lname"
                                                        label="* Last name:"
                                                        variant="outlined"
                                                        focused
                                                        value={getLastname}
                                                        onChange={handleLastname}
                                                    />
                                                    <p> {geterror.last} </p>
                                                </div>
                                            </div>
                                            <TextField
                                                id="phone"
                                                label="* Phone Number:"
                                                variant="outlined"
                                                focused
                                                value={getPhone}
                                                onChange={handlePhone}
                                            />
                                            <p> {geterror.phone} </p>
                                            <TextField
                                                id="email"
                                                type="email"
                                                label="* Email:"
                                                variant="outlined"
                                                focused
                                                value={getyouremail}
                                                onChange={handleYouremail}
                                            />
                                            <p> {geterror.email} </p>
                                            <ReCAPTCHA
                                                sitekey={setting.site_key}
                                                onChange={onChange}
                                            />
                                            <div style={{ marginTop: "20px" }}>
                                                <div className="gf-form-buttons">
                                                    <button
                                                        type="button"
                                                        id="ringbuilder_mail_btn_q78er"
                                                        className="btn  button preference-btn"
                                                        onClick={() =>
                                                            addFormData(props.props)
                                                        }
                                                        disabled={
                                                            reCaptchaValue ? false : true
                                                        }
                                                    >
                                                        <span>Submit Inquiry</span>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn button preference-btn skip-btn"
                                                        onClick={() =>
                                                            setIsOpen2(false)
                                                        }
                                                    >
                                                        <span>Skip</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </Modal>
                            : ''}
                        {setting.multiple_wishlist_option == "true" ?
                            <Modal
                                open={isOpen}
                                onClose={() => { setIsOpen(false); setIsOpen2(true) }}
                                center
                                classNames={{
                                    overlay: "popup_Overlay",
                                    modal: "popup-form-extra-small"
                                }}
                            >
                                {/* <LoadingOverlay className="_loading_overlay_wrapper">
                                    <Loader fullPage loading={loaded} />
                                </LoadingOverlay> */}
                                <div className="gf-wishlist-create-select-form">
                                    <h2 className="gf-wishlist-head">Add Product To Your Wishlist</h2>
                                    <div className="gf-wishlist-main-container">
                                        <div className="gf-wishlist-product-details">
                                            <h4>Product Details : </h4>
                                            <div>
                                                <p><b>Name - </b>{productDetail.title}</p>

                                                <p><b>Price - </b>{(parseInt(productDetail.price) / 100).toLocaleString("en-US", { style: "currency", currency: currency })}</p>
                                            </div>
                                            {setting.plan > 1 ?
                                                <div className="gf-w-quantity">
                                                    <label style={{ marginRight: "10px" }}><b>Quantity</b></label>
                                                    <input type="number" onChange={(e) => setproductQuantity(e.target.value)} />
                                                    {productQuantity == '' && addtolistError ? <small className="gf-error-msg"> * Please enter Quantity</small> : ''}
                                                </div>
                                                : ""}
                                        </div>

                                        <div className="gf-wishlists-data">
                                            <h5 style={{ margin: 0 }}>{Object.keys(getWishlist).length > 0 ? 'Select Your Existing Wishlist' : ''}</h5>
                                            {Object.keys(getWishlist).map((key, i) =>
                                                <div className="gf-wishlists-input">
                                                    <label>{key}</label>
                                                    <input value={getWishlist[key]} type="radio" name="wishlist" onChange={(e) => { setSelectwishlist(e); setnewwishlistfields(false); }} />
                                                </div>
                                            )}
                                            <hr className="gf-seperator" />
                                            <div className="gf-for-new-add">
                                                <h5>Do you want create a Wishlist?</h5>
                                                <input type="radio" name="wishlist" onChange={(e) => setnewwishlistfields(!newwishlistfields)} />
                                            </div>

                                            {newwishlistfields ? (
                                                <div className='gf-wishlists-input'>
                                                    <input type="text" placeholder="Add new Wishlist name" onChange={(e) => setnewwishlist(e)} />
                                                    {newwishlist == '' && addtolistError ? <small className="gf-error-msg"> * Please enter Wishlist name</small> : ''}

                                                    {/* <input value={newwishlist} type="radio" name="wishlist" onChange={(e) => setSelectwishlist(e)} /> */}
                                                </div>
                                            ) : ''}

                                            {setting.wishlist_comments_option != "false" ?
                                                <div className="gf-for-new-add">
                                                    <h5>Do you want drop comments?</h5>
                                                    <input type="checkbox" onChange={(e) => setWishlistCommenttoggle(!WishlistCommenttoggle)} checked={WishlistCommenttoggle ? 'checked' : ''} />
                                                </div>
                                                : ''}
                                            {setting.wishlist_comments_option != "false" ?
                                                WishlistCommenttoggle ? (
                                                    <div className='gf-wishlists-input'>
                                                        <textarea placeholder="Add Comments" onChange={(e) => setWishlistComment(e)} ></textarea>
                                                    </div>
                                                ) : ''
                                                : ''}



                                            {addtolistError && Object.keys(getWishlist).length <= 0 ? <small className="gf-error-msg">* Please create a wishlist. You don't have any existing wishlist.</small> : ''}

                                            {!Selectwishlist && Object.keys(getWishlist).length > 0 && addtolistError ? <small className="gf-error-msg">* Please select a wishlist.</small> : ''}
                                        </div>
                                    </div>
                                    <div className="add_to_list_btns">
                                        <button onClick={() => ((Selectwishlist && !newwishlistfields) || (newwishlistfields && newwishlist != '')) && productQuantity > 0 ? handleAddClick() : setaddtolistError(true)}>Add to Wishlist</button>
                                    </div>
                                </div>
                            </Modal>
                            : ''}
                    </>
                }

                {/* <LoadingOverlay className="_loading_overlay_wrapper">
                    <Loader fullPage loading={loaded} />
                </LoadingOverlay> */}
                <div className="gemfind_wishlist_heart_icon">
                    {click === true ? (
                        <div className="tooltip">
                            <IoHeart
                                className="heart "
                                onClick={() => {
                                    if (!planUpgradable) {
                                        handleRemoveClick()
                                    } else {
                                        setIsOpen(true);
                                    }
                                }
                                }
                            />
                            <span className="tooltiptext">
                                Remove from wishlist
                            </span>
                        </div>
                    ) : (
                        <div className="tooltip">
                            <IoHeartOutline
                                className="heart"
                                onClick={() => {
                                    setIsOpen(true);
                                    if (!planUpgradable) {
                                        setloadApi(true);
                                        if (setting.multiple_wishlist_option == "false") { handleAddClick(); }
                                    }
                                }}
                            />
                            <span className="tooltiptext">Add to Wishlist</span>
                        </div>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <div>
                <style>
                    {`
                .heart{
                    color: ${setting.wishlist_icon_color}
                }
                .react-overlay-loader-spinner {
                    background-image: url(${process.env.REACT_APP_IMAGE_URL}+"images/heart_loader.gif");
                }
            `}
                </style>
                {planUpgradable ?
                    <Modal
                        open={isOpen}
                        onClose={() => setIsOpen(false)}
                        center
                        classNames={{
                            overlay: "popup_Overlay",
                            modal: "popup-form-extra-small plan--modal"
                        }}
                    >
                        <p>Wishlist limit is over, Please contact Us for more information.</p>
                    </Modal>
                    : <>
                        {setting.request_info == "true" ?
                            <Modal
                                open={isOpen2}
                                onClose={() => { setIsOpen2(false); setnewwishlistfields(false); }}
                                center
                                classNames={{
                                    overlay: "popup_Overlay",
                                    modal: "popup-form-extra-small"
                                }}
                            >
                                {/* <LoadingOverlay className="_loading_overlay_wrapper">
                                    <Loader fullPage loading={loaded} />
                                </LoadingOverlay> */}
                                <div className="Diamond-form--xx-small request--more-info-popup">
                                    <div className="requested-form">
                                        <h2>Request More Information</h2>
                                    </div>
                                    <form
                                        // onSubmit={ () =>
                                        //     addFormData(props.props)
                                        // }
                                        className="email-form"
                                    >
                                        <div className="form-field">
                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <div style={{ width: "100%" }}>
                                                    <TextField
                                                        id="fname"
                                                        label="* First name:"
                                                        variant="outlined"
                                                        focused
                                                        value={getFirstname}
                                                        onChange={handleFirstname}
                                                    />
                                                    <p> {geterror.first} </p>
                                                </div>
                                                <div style={{ width: "100%" }}>
                                                    <TextField
                                                        id="lname"
                                                        label="* Last name:"
                                                        variant="outlined"
                                                        focused
                                                        value={getLastname}
                                                        onChange={handleLastname}
                                                    />
                                                    <p> {geterror.last} </p>
                                                </div>
                                            </div>
                                            <TextField
                                                id="phone"
                                                label="* Phone Number:"
                                                variant="outlined"
                                                focused
                                                value={getPhone}
                                                onChange={handlePhone}
                                            />
                                            <p> {geterror.phone} </p>
                                            <TextField
                                                id="email"
                                                type="email"
                                                label="* Email:"
                                                variant="outlined"
                                                focused
                                                value={getyouremail}
                                                onChange={handleYouremail}
                                            />
                                            <p> {geterror.email} </p>
                                            {/* <ReCAPTCHA
                                    sitekey={process.env.REACT_APP_SITE_KEY}
                                    onChange={onChange}
                                /> */}
                                            <div style={{ marginTop: "20px" }}>
                                                <div className="gf-form-buttons">
                                                    <button
                                                        type="button"
                                                        id="ringbuilder_mail_btn_q78er"
                                                        className="btn  button preference-btn"
                                                        onClick={() =>
                                                            addFormData(props.props)
                                                        }
                                                    // disabled={
                                                    //     reCaptchaValue ? false : true
                                                    // }
                                                    >
                                                        <span>Submit Inquiry</span>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn button preference-btn  skip-btn"
                                                        onClick={() =>
                                                            setIsOpen2(false)
                                                        }
                                                    >
                                                        <span>Skip</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </Modal>
                            : ''}
                        {setting.multiple_wishlist_option == "true" ?
                            <Modal
                                open={isOpen}
                                onClose={() => { setIsOpen(false); setIsOpen2(true) }}
                                center
                                classNames={{
                                    overlay: "popup_Overlay",
                                    modal: "popup-form-extra-small"
                                }}
                            >
                                {/* <LoadingOverlay className="_loading_overlay_wrapper">
                                    <Loader fullPage loading={loaded} />
                                </LoadingOverlay> */}
                                <div className="gf-wishlist-create-select-form">
                                    <h2 className="gf-wishlist-head">Add Product To Your Wishlist</h2>
                                    <div className="gf-wishlist-main-container">
                                        <div className="gf-wishlist-product-details">
                                            <h4>Product Details : </h4>
                                            <div>
                                                <p><b>Name - </b>{productDetail.title}</p>

                                                <p><b>Price - </b>{(parseInt(productDetail.price) / 100).toLocaleString("en-US", { style: "currency", currency: currency })}</p>
                                            </div>
                                            {setting.plan > 1 ?
                                                <div className="gf-w-quantity">
                                                    <label style={{ marginRight: "10px" }}><b>Quantity</b></label>
                                                    <input type="number" onChange={(e) => setproductQuantity(e.target.value)} />
                                                    {productQuantity == '' && addtolistError ? <small className="gf-error-msg"> * Please enter Quantity</small> : ''}
                                                </div>
                                                : ""}
                                        </div>

                                        <div className="gf-wishlists-data">
                                            <h5 style={{ margin: 0 }}>{Object.keys(getWishlist).length > 0 ? 'Select Your Existing Wishlist' : ''}</h5>
                                            {Object.keys(getWishlist).map((key, i) =>
                                                <div className="gf-wishlists-input">
                                                    <label>{key}</label>
                                                    <input value={getWishlist[key]} type="radio" name="wishlist" onChange={(e) => { setSelectwishlist(e); setnewwishlistfields(false); }} />
                                                </div>
                                            )}
                                            <hr className="gf-seperator" />
                                            <div className="gf-for-new-add">
                                                <h5>Do you want create a Wishlist?</h5>
                                                <input type="radio" name="wishlist" onChange={(e) => setnewwishlistfields(!newwishlistfields)} />
                                            </div>

                                            {newwishlistfields ? (
                                                <div className='gf-wishlists-input'>
                                                    <input type="text" placeholder="Add new Wishlist name" onChange={(e) => setnewwishlist(e)} />
                                                    {newwishlist == '' && addtolistError ? <small className="gf-error-msg"> * Please enter Wishlist name</small> : ''}

                                                    {/* <input value={newwishlist} type="radio" name="wishlist" onChange={(e) => setSelectwishlist(e)} /> */}
                                                </div>
                                            ) : ''}

                                            {setting.wishlist_comments_option != "false" ?
                                                <div className="gf-for-new-add">
                                                    <h5>Do you want drop comments?</h5>
                                                    <input type="checkbox" onChange={(e) => setWishlistCommenttoggle(!WishlistCommenttoggle)} checked={WishlistCommenttoggle ? 'checked' : ''} />
                                                </div>
                                                : ''}
                                            {setting.wishlist_comments_option != "false" ?
                                                WishlistCommenttoggle ? (
                                                    <div className='gf-wishlists-input'>
                                                        <textarea placeholder="Add Comments" onChange={(e) => setWishlistComment(e)} ></textarea>
                                                    </div>
                                                ) : ''
                                                : ''}



                                            {addtolistError && Object.keys(getWishlist).length <= 0 ? <small className="gf-error-msg">* Please create a wishlist. You don't have any existing wishlist.</small> : ''}

                                            {!Selectwishlist && Object.keys(getWishlist).length > 0 && addtolistError ? <small className="gf-error-msg">* Please select a wishlist.</small> : ''}

                                        </div>
                                    </div>
                                    <div className="add_to_list_btns">
                                        <button onClick={() => ((Selectwishlist && !newwishlistfields) || (newwishlistfields && newwishlist != '')) && productQuantity > 0 ? handleAddClick() : setaddtolistError(true)}>Add to Wishlist</button>
                                    </div>
                                </div>
                            </Modal>
                            : ''}
                    </>
                }
                {/* <LoadingOverlay className="_loading_overlay_wrapper">
                    <Loader fullPage loading={loaded} />
                </LoadingOverlay> */}
                <div className="gemfind_wishlist_heart_icon">
                    {click === true ? (
                        <div className="tooltip">
                            <IoHeart
                                className="heart "
                                onClick={() => {
                                    if (!planUpgradable) {
                                        handleRemoveClick()
                                    } else {
                                        setIsOpen(true);
                                    }
                                }
                                }
                            />
                            <span className="tooltiptext">
                                Remove from wishlist
                            </span>
                        </div>
                    ) : (
                        <div className="tooltip">
                            <IoHeartOutline
                                className="heart"
                                onClick={() => {
                                    setIsOpen(true);
                                    if (!planUpgradable) {
                                        setloadApi(true);
                                        if (setting.multiple_wishlist_option == "false") { handleAddClick(); }
                                    }
                                }}
                            />
                            <span className="tooltiptext">Add to Wishlist</span>
                        </div>
                    )}
                </div>
            </div>
        );
    }
};
export default ProductListPage;
